import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import React from 'react';
import styled from 'styled-components';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import Page from '../components/Page';
import { sendEvent } from '../utils/firebase';

const Section = styled.section`
  position: relative;
  width: 100%;

  img {
    width: 100%;
    height: 100%;
  }
`;

const SliderWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 7.116129%;
  right: 0;
  width: 80.7291667%;
  margin: 0 auto;

  .swiper-pagination-bullet-active {
    background: white;
  }

  .swiper-button-disabled {
    opacity: 0;
    pointer-events: auto;
  }

  .swiper-button-next {
    height: 100%;
    top: 0;
    right: 0;

    margin-top: 0;

    width: 10%;
    z-index: 999;
  }

  .swiper-button-prev {
    height: 100%;
    top: 0;
    left: 0;

    margin-top: 0;

    width: 10%;
    z-index: 999;
  }

  --swiper-navigation-size: 26px;
  --swiper-theme-color: #858585;
`;

const SliderItem = styled.a`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  img:first-of-type {
    max-width: 78.5185185%;
    height: auto;
  }

  img:last-of-type {
    position: absolute;
    margin: 0 auto;
    top: 50%;
    transform: translateY(-50%);
    height: auto;
    max-height: 66px;
    width: 56.7099567%;
    max-width: 301px;

    @media (min-width: 1200px) {
      max-height: initial;
      max-width: initial;
    }
  }
`;

const Link01 = styled.a`
  position: absolute;
  left: 10.4166667%;
  bottom: 16.916129%;
  width: 33.0729167%;
  max-height: 54px;
`;

const Link02 = styled.a`
  position: absolute;
  left: 0;
  bottom: 79%;
  right: 0;
  margin: 0 auto;
  display: block;
  width: 77.2135417%;
`;

const Link03 = styled.a`
  position: absolute;
  left: 0;
  bottom: 70%;
  right: 0;
  margin: 0 auto;
  display: block;
  width: 77.2135417%;
`;

const Link04 = styled.a`
  position: absolute;
  left: 0;
  bottom: 62.5%;
  right: 0;
  margin: 0 auto;
  display: block;
  width: 77.2135417%;
`;

const Link05 = styled.a`
  position: absolute;
  left: 0;
  bottom: 19.5%;
  right: 0;
  margin: 0 auto;
  display: block;
  width: 77.2135417%;
`;

const DownloadGoogle = styled.a`
  position: absolute;
  left: 27.416667%;
  bottom: 7.216129%;
  width: 16%;
  max-height: 41px;
`;

const DownloadApple = styled.a`
  position: absolute;
  left: 10.4166667%;
  bottom: 7.216129%;
  width: 16%;
  max-height: 41px;
`;

const links = {
  Link01: 'https://bit.ly/3I2voad',
  Link02: 'https://bit.ly/3pRuO91',
  Link03: 'https://bit.ly/3MD2t01',
  Link04: 'https://bit.ly/3I4VObj',
  Link05: 'https://bit.ly/3tQy2dU',
  Slider01: 'https://bit.ly/3L2utsn',
  Slider02: 'https://bit.ly/3MHopHm',
  Slider03: 'https://bit.ly/3I9ESk8',
  Slider04: 'https://bit.ly/3t2CuqS',
  DownloadGoogle: 'https://glamapp.onelink.me/6V4I/d509c01d',
  DownloadApple: 'https://glamapp.onelink.me/6V4I/d509c01d',
};

const EVENT_NAMES = {
  CLICK__GLAM_LIVE: 'click__glam_live', // 글램 라이브 더 알아보기 버튼 클릭 수
  CLICK__APP_INSTALL_GOOGLE: 'click__app_install_google', // 앱 스토어 / 구글 플레이 스토어 버튼 클릭 수
  CLICK__APP_INSTALL_APPLE: 'click__app_install_apple',
  CLICK__VIDEO_GUIDE: 'click__video_guide', // 지원 가이드 영상 보러가기 버튼 클릭 수
  CLICK__VIDEO_LIVE_HOST_DANCE: 'click__video_live_host_dance', // 라이브 호스트 영상 (댄스) 보러가기 버튼 클릭 수
  CLICK__VIDEO_LIVE_HOST_CRAZY: 'click__video_live_host_crazy', // 라이브 호스트 영상 (똘끼) 보러가기 버튼 클릭 수
  CLICK__VIDEO_LIVE_HOST_TAROT: 'click__video_live_host_tarot', // 라이브 호스트 영상 (타로) 보러가기 버튼 클릭 수
  CLICK__APPLY_CONTEST: 'click__apply_contest', // 콘텐츠 응모하기 버튼 클릭 수
  CLICK__LIVE_HOST: 'click__live_host', // 글램 라이브 호스트 알아보기 버튼 클릭 수
  CLICK__SET_NOTIFICATION: 'click__set_notification', // 콘테스트 소식 자동아림 받기 버튼 클릭 수
  CLICK__LOGO_DOWNLOAD: 'click__logo_download', // 로고 다운로드
};

const onClickLink = (eventName: string) => () => sendEvent(eventName);

export default () => (
  <Page>
    <Section>
      <img
        srcSet="/images/1_1586px.png 1200w, /images/1_768px.png 1x, /images/1_1586px.png 2x"
        src="/images/1_768px.png"
        alt=""
      />
    </Section>
    <Section>
      <img
        srcSet="/images/2_1586px.png 1200w, /images/2_768px.png 1x, /images/2_1586px.png 2x"
        src="/images/2_768px.png"
        alt=""
      />
      <Link01 href={links.Link01} target="_blank" onClick={onClickLink(EVENT_NAMES.CLICK__GLAM_LIVE)}>
        <img
          srcSet="/images/button01_1586px.png 1200w, /images/button01_768px.png 1x, /images/button01_1586px.png 2x"
          src="/images/button01_768px.png"
          alt=""
        />
      </Link01>
      <DownloadApple
        href={links.DownloadApple}
        target="_blank"
        onClick={onClickLink(EVENT_NAMES.CLICK__APP_INSTALL_APPLE)}
      >
        <img
          srcSet="/images/download_apple_1586px.png 1200w, /images/download_apple_768px.png 1x, /images/download_apple_1586px.png 2x"
          src="/images/download_apple_768px.png"
          alt=""
        />
      </DownloadApple>
      <DownloadGoogle
        href={links.DownloadGoogle}
        target="_blank"
        onClick={onClickLink(EVENT_NAMES.CLICK__APP_INSTALL_GOOGLE)}
      >
        <img
          srcSet="/images/download_google_1586px.png 1200w, /images/download_google_768px.png 1x, /images/download_google_1586px.png 2x"
          src="/images/download_google_768px.png"
          alt=""
        />
      </DownloadGoogle>
    </Section>
    <Section>
      <img
        srcSet="/images/3_1586px.png 1200w, /images/3_768px.png 1x, /images/3_1586px.png 2x"
        src="/images/3_768px.png"
        alt=""
      />
    </Section>
    <Section>
      <img
        srcSet="/images/4_1586px.png 1200w, /images/4_768px.png 1x, /images/4_1586px.png 2x"
        src="/images/4_768px.png"
        alt=""
      />
    </Section>
    <Section>
      <img
        srcSet="/images/5_1586px.png 1200w, /images/5_768px.png 1x, /images/5_1586px.png 2x"
        src="/images/5_768px.png"
        alt=""
      />

      <SliderWrapper>
        <Swiper
          centeredSlides
          navigation
          slidesPerView="auto"
          slidesPerGroup={1}
          modules={[Pagination, Navigation]}
          pagination={{ clickable: true }}
        >
          <SwiperSlide>
            <SliderItem href={links.Slider01} target="_blank" onClick={onClickLink(EVENT_NAMES.CLICK__VIDEO_GUIDE)}>
              <img
                srcSet="/images/slide01_768px.png 1x, /images/slide01_1586px.png 2x"
                alt=""
                src="/images/slide01_768px.png"
              />
              <img
                srcSet="/images/slide01_text_1586px.png 1200w, /images/slide01_text_768px.png 1x, /images/slide01_text_1586px.png 2x"
                alt=""
                src="/images/slide01_text_768px.png"
              />
            </SliderItem>
          </SwiperSlide>
          <SwiperSlide>
            <SliderItem
              href={links.Slider02}
              target="_blank"
              onClick={onClickLink(EVENT_NAMES.CLICK__VIDEO_LIVE_HOST_DANCE)}
            >
              <img
                srcSet="/images/slide02_1586px.png 1200w, /images/slide02_768px.png 1x, /images/slide02_1586px.png 2x"
                alt=""
                src="/images/slide02_768px.png"
              />
              <img
                srcSet="/images/slide02_text_1586px.png 1200w, /images/slide02_text_768px.png 1x, /images/slide02_text_1586px.png 2x"
                alt=""
                src="/images/slide02_text_768px.png"
              />
            </SliderItem>
          </SwiperSlide>
          <SwiperSlide>
            <SliderItem
              href={links.Slider03}
              target="_blank"
              onClick={onClickLink(EVENT_NAMES.CLICK__VIDEO_LIVE_HOST_CRAZY)}
            >
              <img
                srcSet="/images/slide03_1586px.png 1200w, /images/slide03_768px.png 1x, /images/slide03_1586px.png 2x"
                alt=""
                src="/images/slide03_768px.png"
              />
              <img
                srcSet="/images/slide03_text_1586px.png 1200w, /images/slide03_text_768px.png 1x, /images/slide03_text_1586px.png 2x"
                alt=""
                src="/images/slide03_text_768px.png"
              />
            </SliderItem>
          </SwiperSlide>
          <SwiperSlide>
            <SliderItem
              href={links.Slider04}
              target="_blank"
              onClick={onClickLink(EVENT_NAMES.CLICK__VIDEO_LIVE_HOST_TAROT)}
            >
              <img
                srcSet="/images/slide04_1586px.png 1200w, /images/slide04_768px.png 1x, /images/slide04_1586px.png 2x"
                alt=""
                src="/images/slide04_768px.png"
              />
              <img
                srcSet="/images/slide04_text_1586px.png 1200w, /images/slide04_text_768px.png 1x, /images/slide04_text_1586px.png 2x"
                alt=""
                src="/images/slide04_text_768px.png"
              />
            </SliderItem>
          </SwiperSlide>
        </Swiper>
      </SliderWrapper>
    </Section>
    <Section>
      <img
        srcSet="/images/6_1586px.png 1200w, /images/6_768px.png 1x, /images/6_1586px.png 2x"
        src="/images/6_768px.png"
        alt=""
      />
    </Section>
    <Section>
      <img
        srcSet="/images/7_1586px.png 1200w, /images/7_768px.png 1x, /images/7_1586px.png 2x"
        src="/images/7_768px.png"
        alt=""
      />
    </Section>
    <Section>
      <img
        srcSet="/images/8_1586px.png 1200w, /images/8_768px.png 1x, /images/8_1586px.png 2x"
        src="/images/8_768px.png"
        alt=""
      />
    </Section>
    <Section>
      <img
        srcSet="/images/9_1586px.png 1200w, /images/9_768px.png 1x, /images/9_1586px.png 2x"
        src="/images/9_768px.png"
        alt=""
      />
    </Section>
    <Section>
      <img
        srcSet="/images/10_1586px.png 1200w, /images/10_768px.png 1x, /images/10_1586px.png 2x"
        src="/images/10_768px.png"
        alt=""
      />
      <Link02 href={links.Link02} target="_blank" onClick={onClickLink(EVENT_NAMES.CLICK__APPLY_CONTEST)}>
        <img
          srcSet="/images/button02_1586px.png 1200w, /images/button02_768px.png 1x, /images/button02_1586px.png 2x"
          src="/images/button02_768px.png"
          alt=""
        />
      </Link02>
      <Link03 href={links.Link03} target="_blank" onClick={onClickLink(EVENT_NAMES.CLICK__LIVE_HOST)}>
        <img
          srcSet="/images/button03_1586px.png 1200w, /images/button03_768px.png 1x, /images/button03_1586px.png 2x"
          src="/images/button03_768px.png"
          alt=""
        />
      </Link03>
      <Link04 href={links.Link04} target="_blank" onClick={onClickLink(EVENT_NAMES.CLICK__SET_NOTIFICATION)}>
        <img
          srcSet="/images/button04_1586px.png 1200w, /images/button04_768px.png 1x, /images/button04_1586px.png 2x"
          src="/images/button04_768px.png"
          alt=""
        />
      </Link04>
      <Link05 href={links.Link05} target="_blank" onClick={onClickLink(EVENT_NAMES.CLICK__LOGO_DOWNLOAD)}>
        <img
          srcSet="/images/button05_1586px.png 1200w, /images/button05_768px.png 1x, /images/button05_1586px.png 2x"
          src="/images/button05_768px.png"
          alt=""
        />
      </Link05>
    </Section>
    <Section>
      <img
        srcSet="/images/11_1586px.png 1200w, /images/11_768px.png 1x, /images/11_1586px.png 2x"
        src="/images/11_768px.png"
        alt=""
      />
    </Section>
  </Page>
);
